import script from "./Background.vue?vue&type=script&setup=true&lang=js"
export * from "./Background.vue?vue&type=script&setup=true&lang=js"

import "./Background.vue?vue&type=style&index=0&id=d757310a&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d757310a"]])

export default __exports__